// This is a modal for Adminvendorsone

import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";
import { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { InfoCircleIcon } from "./assets";
import {
  addVendorsonhome,
  uploadImage,
} from "./redux/slices/VendorsonhomeThunks";
import RichTextEditor from "./prtnr/ui/RichTextEditor";

export default function ModalAdminvendorsone({ onClose, sector, errorModal }) {
  const dispatch = useDispatch();
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    company_name: "",
    compay_logo: "",
    sector: "",
    company_size: "",
    locations: "",
    vendor_hq: "",
    typical_budget: "",
    typical_decision_maker: "",
    typical_scenario: "",
    typical_pain_points: "",
    year_founded: "",
    average_sales_cycle_in_months: "",
    company_website_url: "",
    website_thumbnail: "",
    no_of_employees: "",
    vendor_firstname: "",
    vendor_lastname: "",
    vendor_work_email: "",
    vendor_profile_status: "Draft",
    ideal_profile: "",
    short_description: "",
    vendor_industry_sector: [],
    message: "",
    ceo_name: "",
    picture: "",
    about: "",
    contact_number: "",
    created_at: Date.now(),
  });

  const fieldRefs = {
    vendor_firstname: useRef(null),
    vendor_lastname: useRef(null),
    vendor_work_email: useRef(null),
    company_name: useRef(null),
    compay_logo: useRef(null),
    company_website_url: useRef(null),
    website_thumbnail: useRef(null),
    year_founded: useRef(null),
    vendor_hq: useRef(null),
    sector: useRef(null),
    company_size: useRef(null),
    locations: useRef(null),
    typical_budget: useRef(null),
    typical_decision_maker: useRef(null),
    typical_scenario: useRef(null),
    typical_pain_points: useRef(null),
    average_sales_cycle_in_months: useRef(null),
    vendor_industry_sector: useRef(null),
    contact_number: useRef(null),
    short_description: useRef(null),
  };

  const handleFieldChange = async (key, value) => {
    try {
      const res = await dispatch(uploadImage(value));
      console.log(res.payload.fileURL);
      setFormData((prev) => ({
        ...prev,
        [key]: res.payload.fileURL,
      }));
    } catch (e) {
      console.log(e, "error");
    }
  };

  function isValidUKPhone(phone) {
    const cleaned = phone.replace(/\s+/g, "");
    return /^(?:\+44|0044|0)(?:7\d{9}|1\d{9}|2\d{9}|3\d{9}|5\d{9}|8\d{9}|9\d{9})$/.test(
      cleaned
    );
  }

  const handler = async () => {
    setHasSubmitted(true);
    const requiredFields = [
      "vendor_firstname",
      "vendor_lastname",
      "vendor_work_email",
      "company_name",
      "compay_logo",
      "company_website_url",
      "website_thumbnail",
      "year_founded",
      "vendor_hq",
      "sector",
      "company_size",
      "locations",
      "typical_budget",
      "typical_decision_maker",
      "typical_scenario",
      "typical_pain_points",
      "average_sales_cycle_in_months",
      "vendor_industry_sector",
      "contact_number",
      "short_description",
    ];

    const emptyFields = requiredFields.filter((field) => {
      const value = formData[field];
      // Handle array fields (like multi-select)
      if (Array.isArray(value)) {
        return value.length === 0;
      }
      // Handle string fields
      return !value || value.toString().trim() === "";
    });

    const phoneIsInvalid = !isValidUKPhone(formData.contact_number);

    const firstInvalidField = phoneIsInvalid
      ? "contact_number"
      : emptyFields.length
      ? emptyFields[0]
      : null;

    if (firstInvalidField && fieldRefs[firstInvalidField]?.current) {
      fieldRefs[firstInvalidField].current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      fieldRefs[firstInvalidField].current.focus();
      return;
    }

    const res = await dispatch(addVendorsonhome(formData));
    if (res?.payload?.message == "Email already exists!") errorModal();
    onClose();
    setHasSubmitted(false);
  };

  return (
    <RootWrapperModalAdminvendorsone>
      <Wrapper>
        <Sector>
          <Left>
            <Frame58>
              <Frame1391>
                <AddVendor>Add Vendor</AddVendor>
              </Frame1391>
              <ModalAdminVendors01>
                <VednorFourm>
                  <VendorInformation>Primary Contact</VendorInformation>
                  <Frame1409>
                    <PRTNR.Input
                      label="First Name"
                      value={formData.vendor_firstname}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          vendor_firstname: e.target.value,
                        });
                      }}
                      required
                      error={hasSubmitted && !formData.vendor_firstname}
                      errorMessage={"Required Field"}
                      ref={fieldRefs?.vendor_firstname}
                    />

                    <PRTNR.Input
                      label="Last Name"
                      value={formData.vendor_lastname}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          vendor_lastname: e.target.value,
                        });
                      }}
                      required
                      error={hasSubmitted && !formData.vendor_lastname}
                      errorMessage={"Required Field"}
                      ref={fieldRefs?.vendor_lastname}
                    />
                  </Frame1409>
                  <PRTNR.Input
                    label="Work email address"
                    value={formData.vendor_work_email}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        vendor_work_email: e.target.value,
                      });
                    }}
                    required
                    error={hasSubmitted && !formData.vendor_work_email}
                    errorMessage={"Required Field"}
                    ref={fieldRefs?.vendor_work_email}
                  />

                  <PRTNR.Input
                    label="Phone"
                    value={formData.contact_number}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        contact_number: e.target.value,
                      });
                    }}
                    required
                    error={
                      hasSubmitted &&
                      (!formData.contact_number ||
                        !isValidUKPhone(formData.contact_number))
                    }
                    errorMessage={
                      !formData.contact_number
                        ? "Required Field"
                        : !isValidUKPhone(formData.contact_number)
                        ? "Enter a valid UK phone number"
                        : ""
                    }
                    ref={fieldRefs?.contact_number}
                  />

                  <Frame1406>
                    <VendorInformation>Vendor Information</VendorInformation>
                    <Frame1407>
                      <PRTNR.Input
                        label="Company name"
                        value={formData.company_name}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            company_name: e.target.value,
                          });
                        }}
                        required
                        error={hasSubmitted && !formData.company_name}
                        errorMessage={"Required Field"}
                        ref={fieldRefs?.company_name}
                      />

                      <PRTNR.Input
                        label={
                          <LabelWrapper>
                            <span>
                              Short Description <Required>*</Required>
                            </span>
                            <TooltipWrapper>
                              <GFeildsInfo src={InfoCircleIcon} alt="icon" />
                              <TooltipText className="tooltip">
                                Less than 20 characters.
                              </TooltipText>
                            </TooltipWrapper>
                          </LabelWrapper>
                        }
                        value={formData.short_description}
                        onChange={(e) => {
                          if (e.target.value.length <= 20) {
                            setFormData({
                              ...formData,
                              short_description: e.target.value,
                            });
                          }
                        }}
                      />
                      <RichTextEditor
                        label={
                          <LabelWrapper>
                            <span>About</span>
                            <TooltipWrapper>
                              <GFeildsInfo src={InfoCircleIcon} alt="icon" />
                              <TooltipText className="tooltip">
                                Describe your company's services. Less than 50
                                characters.
                              </TooltipText>
                            </TooltipWrapper>
                          </LabelWrapper>
                        }
                        value={formData.about}
                        onChange={(content) => {
                          setFormData((prev) => ({
                            ...prev,
                            about: content,
                          }));
                        }}
                        placeholder="Describe your company's services..."
                        minHeight="200px"
                      />
                      <PRTNR.MultiSelect
                        label="Industry sector"
                        value={formData.vendor_industry_sector}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            vendor_industry_sector: e.target.value,
                          });
                        }}
                        options={sector}
                        required={true}
                        error={hasSubmitted && (!formData.vendor_industry_sector || formData.vendor_industry_sector.length === 0)}
                        errorMessage={"At least one industry sector is required"}
                        ref={fieldRefs?.vendor_industry_sector}
                      />

                      {formData.compay_logo && (
                        <ImageContainer style={{ marginTop: 8 }}>
                          <DisplayImage
                            src={formData.compay_logo}
                            alt="Company Logo Preview"
                            style={{
                              width: 100,
                              height: "auto",
                              borderRadius: 8,
                            }}
                          />
                        </ImageContainer>
                      )}

                      <PRTNR.FileInput
                        label="Company Logo"
                        helpText="JPG, GIF or PNG. Max file size 800kb"
                        accept=".jpg,.jpeg,.gif,.png"
                        onChange={(e) => {
                          if (e) {
                            handleFieldChange("compay_logo", e);
                          } else {
                            console.log("No file selected");
                          }
                        }}
                        name="profile_picture"
                        value={formData.compay_logo}
                        required={true}
                        error={hasSubmitted && !formData.compay_logo}
                        errorMessage={"Required Field"}
                        ref={fieldRefs?.compay_logo}
                      />

                      <PRTNR.Input
                        label="Company Website"
                        value={formData.company_website_url}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            company_website_url: e.target.value,
                          });
                        }}
                        required
                        error={hasSubmitted && !formData.company_website_url}
                        errorMessage={"Required Field"}
                        ref={fieldRefs?.company_website_url}
                      />

                      {formData.website_thumbnail && (
                        <ImageContainer style={{ marginTop: 8 }}>
                          <DisplayImage
                            src={formData.website_thumbnail}
                            alt="Website Thumbnail Preview"
                            style={{
                              width: 100,
                              height: "auto",
                              borderRadius: 8,
                            }}
                          />
                        </ImageContainer>
                      )}

                      <PRTNR.FileInput
                        label="Website Thumbnail"
                        helpText="JPG, GIF or PNG. Max file size 800kb"
                        accept=".jpg,.jpeg,.gif,.png"
                        onChange={(e) => {
                          if (e) {
                            handleFieldChange("website_thumbnail", e);
                          } else {
                            console.log("No file selected");
                          }
                        }}
                        name="website_thumbnail"
                        value={formData.website_thumbnail}
                        required={true}
                        error={hasSubmitted && !formData.website_thumbnail}
                        errorMessage={"Required Field"}
                        ref={fieldRefs?.website_thumbnail}
                      />
                      <PRTNR.Input
                        label={
                          <LabelWrapper>
                            <span>Stakeholder message to members</span>
                            <TooltipWrapper>
                              <GFeildsInfo src={InfoCircleIcon} alt="icon" />
                              <TooltipText className="tooltip">
                                Please feel free to write a message to potential
                                referrers. Less than 50 characters.
                              </TooltipText>
                            </TooltipWrapper>
                          </LabelWrapper>
                        }
                        value={formData.message}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            message: e.target.value,
                          });
                        }}
                      />
                      <PRTNR.Input
                        label="Stakeholder name"
                        value={formData.ceo_name}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            ceo_name: e.target.value,
                          });
                        }}
                      />

                      {formData.picture && (
                        <ImageContainer style={{ marginTop: 8 }}>
                          <DisplayImage
                            src={formData.picture}
                            alt="Stakeholder Picture Preview"
                            style={{
                              width: 100,
                              height: "auto",
                              borderRadius: 8,
                            }}
                          />
                        </ImageContainer>
                      )}

                      <PRTNR.FileInput
                        label="Stakeholder picture"
                        helpText="JPG, GIF or PNG. Max file size 800kb"
                        accept=".jpg,.jpeg,.gif,.png"
                        onChange={(e) => {
                          if (e) {
                            handleFieldChange("picture", e);
                          } else {
                            console.log("No file selected");
                          }
                        }}
                        name="picture"
                        value={formData.picture}
                      />
                      <Frame1518>
                        <PRTNR.Input
                          label="Year founded"
                          type="number"
                          value={formData.year_founded}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value.length <= 4) {
                              setFormData({
                                ...formData,
                                year_founded: value,
                              });
                            }
                          }}
                          required
                          error={hasSubmitted && !formData.year_founded}
                          errorMessage={"Required Field"}
                          ref={fieldRefs?.year_founded}
                        />

                        <PRTNR.Input
                          label={
                            <LabelWrapper>
                              <span>
                                Vendor HQ <Required>*</Required>
                              </span>
                              <TooltipWrapper>
                                <GFeildsInfo src={InfoCircleIcon} alt="icon" />
                                <TooltipText className="tooltip">
                                  City, Country format for example, London, UK.
                                </TooltipText>
                              </TooltipWrapper>
                            </LabelWrapper>
                          }
                          value={formData.vendor_hq}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              vendor_hq: e.target.value,
                            });
                          }}
                          error={hasSubmitted && !formData.vendor_hq}
                          errorMessage={"Required Field"}
                          ref={fieldRefs?.vendor_hq}
                        />
                      </Frame1518>
                      <Frame1518>
                        <PRTNR.Input
                          label="Number of employees"
                          value={formData.no_of_employees}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              no_of_employees: e.target.value,
                            });
                          }}
                        />
                      </Frame1518>
                    </Frame1407>
                  </Frame1406>
                  <Frame1406>
                    <IdealClientProfile>
                      Ideal Client Profile
                    </IdealClientProfile>
                    <Frame1407>
                      <PRTNR.Input
                        label="Summary"
                        value={formData.ideal_profile}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            ideal_profile: e.target.value,
                          });
                        }}
                      />
                      <PRTNR.Input
                        label={
                          <LabelWrapper>
                            <span>
                              Sectors <Required>*</Required>
                            </span>
                            <TooltipWrapper>
                              <GFeildsInfo src={InfoCircleIcon} alt="icon" />
                              <TooltipText className="tooltip">
                                In which sectors do your ideal client reside in?
                              </TooltipText>
                            </TooltipWrapper>
                          </LabelWrapper>
                        }
                        value={formData.sector}
                        onChange={(e) => {
                          setFormData({ ...formData, sector: e.target.value });
                        }}
                        error={hasSubmitted && !formData.sector}
                        errorMessage={"Required Field"}
                        ref={fieldRefs?.sector}
                      />

                      <Frame1518>
                        <PRTNR.Input
                          label={
                            <LabelWrapper>
                              <span>
                                Typical Company Size <Required>*</Required>
                              </span>
                              <TooltipWrapper>
                                <GFeildsInfo src={InfoCircleIcon} alt="icon" />
                                <TooltipText className="tooltip">
                                  What is the size of your ideal client? (number
                                  of employees, and/or revenue)
                                </TooltipText>
                              </TooltipWrapper>
                            </LabelWrapper>
                          }
                          value={formData.company_size}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              company_size: e.target.value,
                            });
                          }}
                          error={hasSubmitted && !formData.company_size}
                          errorMessage={"Required Field"}
                          ref={fieldRefs?.company_size}
                        />

                        <PRTNR.Input
                          label={
                            <LabelWrapper>
                              <span>
                                Typical Location <Required>*</Required>
                              </span>
                              <TooltipWrapper>
                                <GFeildsInfo src={InfoCircleIcon} alt="icon" />
                                <TooltipText className="tooltip">
                                  Where are your ideal clients located (at a
                                  country level)?
                                </TooltipText>
                              </TooltipWrapper>
                            </LabelWrapper>
                          }
                          value={formData.locations}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              locations: e.target.value,
                            });
                          }}
                          error={hasSubmitted && !formData.locations}
                          errorMessage={"Required Field"}
                          ref={fieldRefs?.locations}
                        />
                      </Frame1518>

                      <PRTNR.Input
                        label={
                          <LabelWrapper>
                            <span>
                              Typical Client Budget <Required>*</Required>
                            </span>
                            <TooltipWrapper>
                              <GFeildsInfo src={InfoCircleIcon} alt="icon" />
                              <TooltipText className="tooltip">
                                What typical budget does your ideal client have?
                              </TooltipText>
                            </TooltipWrapper>
                          </LabelWrapper>
                        }
                        value={formData.typical_budget}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            typical_budget: e.target.value,
                          });
                        }}
                        error={hasSubmitted && !formData.typical_budget}
                        errorMessage={"Required Field"}
                        ref={fieldRefs?.typical_budget}
                      />

                      <PRTNR.Input
                        label={
                          <LabelWrapper>
                            <span>
                              Typical Decision Maker <Required>*</Required>
                            </span>
                            <TooltipWrapper>
                              <GFeildsInfo src={InfoCircleIcon} alt="icon" />
                              <TooltipText className="tooltip">
                                What job titles are the typical decision maker
                                for your services?
                              </TooltipText>
                            </TooltipWrapper>
                          </LabelWrapper>
                        }
                        value={formData.typical_decision_maker}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            typical_decision_maker: e.target.value,
                          });
                        }}
                        error={hasSubmitted && !formData.typical_decision_maker}
                        errorMessage={"Required Field"}
                        ref={fieldRefs?.typical_decision_maker}
                      />

                      <PRTNR.Input
                        label={
                          <LabelWrapper>
                            <span>
                              Typical Scenario <Required>*</Required>
                            </span>
                            <TooltipWrapper>
                              <GFeildsInfo src={InfoCircleIcon} alt="icon" />
                              <TooltipText className="tooltip">
                                In what typical scenarios do your ideal clients
                                come to you?
                              </TooltipText>
                            </TooltipWrapper>
                          </LabelWrapper>
                        }
                        value={formData.typical_scenario}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            typical_scenario: e.target.value,
                          });
                        }}
                        error={hasSubmitted && !formData.typical_scenario}
                        errorMessage={"Required Field"}
                        ref={fieldRefs?.typical_scenario}
                      />

                      <PRTNR.Input
                        label={
                          <LabelWrapper>
                            <span>
                              Typical Pain Points <Required>*</Required>
                            </span>
                            <TooltipWrapper>
                              <GFeildsInfo src={InfoCircleIcon} alt="icon" />
                              <TooltipText className="tooltip">
                                What pain points do your clients typically have?
                              </TooltipText>
                            </TooltipWrapper>
                          </LabelWrapper>
                        }
                        value={formData.typical_pain_points}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            typical_pain_points: e.target.value,
                          });
                        }}
                        error={hasSubmitted && !formData.typical_pain_points}
                        errorMessage={"Required Field"}
                        ref={fieldRefs?.typical_pain_points}
                      />

                      <PRTNR.Input
                        label={
                          <LabelWrapper>
                            <span>
                              Typical Deal Cycle <Required>*</Required>
                            </span>
                            <TooltipWrapper>
                              <GFeildsInfo src={InfoCircleIcon} alt="icon" />
                              <TooltipText className="tooltip">
                                How long is the typical deal cycle? (i.e how
                                long from first contact to contract signing)
                              </TooltipText>
                            </TooltipWrapper>
                          </LabelWrapper>
                        }
                        value={formData.average_sales_cycle_in_months}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            average_sales_cycle_in_months: e.target.value,
                          });
                        }}
                        error={
                          hasSubmitted &&
                          !formData.average_sales_cycle_in_months
                        }
                        errorMessage={"Required Field"}
                        ref={fieldRefs?.average_sales_cycle_in_months}
                      />
                    </Frame1407>
                  </Frame1406>
                </VednorFourm>
                <Frame59>
                  <PRTNR.Button
                    onClick={() => {
                      handler();
                    }}
                    variant="black"
                    size="normal"
                    width={"320px"}
                  >
                    Submit
                  </PRTNR.Button>
                </Frame59>
              </ModalAdminVendors01>
            </Frame58>
          </Left>
        </Sector>
      </Wrapper>
    </RootWrapperModalAdminvendorsone>
  );
}

const RootWrapperModalAdminvendorsone = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  box-sizing: border-box;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  border-radius: 32px;
  padding: 24px;
`;

const Sector = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  width: 560px;
  box-sizing: border-box;
`;

const Left = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 8px;
  width: 560px;
  box-sizing: border-box;
`;

const Frame58 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1391 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const AddVendor = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 30px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const ModalAdminVendors01 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  flex: none;
  gap: 16px;
  border: solid 1px rgba(136, 136, 136, 0.1);
  border-radius: 32px;
  width: 560px;
  background: rgb(226, 232, 240);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 32px;
`;
const Required = styled.span`
  color: rgb(220, 38, 38);
  font-size: 12px;
  font-weight: 700;
  margin-left: 4px;
`;
const VednorFourm = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 16px;
  width: 496px;
  box-sizing: border-box;
`;

const Frame1409 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;


const Frame1406 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  padding: 16px 0px 0px;
  flex-shrink: 0;
`;

const VendorInformation = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 24px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1407 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;
const LabelWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const TooltipWrapper = styled.div`
  position: relative;
  display: inline-block;
  margin-top: 4px;

  &:hover .tooltip {
    visibility: visible;
    opacity: 1;
  }
`;

const TooltipText = styled.div`
  visibility: hidden;
  color: #000000;
  font-weight: 500;
  font-size: 12px;
  text-align: start;
  padding: 8px 16px;
  border-radius: 4px;
  position: absolute;
  z-index: 1;
  top: 125%; /* Show below the icon */
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s;
  max-width: 280px;
  width: 280px;
  backdrop-filter: blur(20px);
  background: var(--backgrounds-primary, #ffffff);
  font-family: "Montserrat", sans-serif;
  &::after {
    content: "";
    position: absolute;
    bottom: 100%; /* Top of the tooltip box */
    left: 50%;
    margin-left: -6px;
    border-width: 6px;
    border-style: solid;
    border-color: transparent transparent var(--backgrounds-primary, #ffffff)
      transparent;
  }
`;



const Frame1518 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;



const GFeildsInfo = styled.img`
  width: 14px;
  height: 14px;
  object-fit: cover;
`;

const IdealClientProfile = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 24px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;


const Frame59 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;


const ImageContainer = styled.div`
  margin-bottom: 8px;
`;

const DisplayImage = styled.img`
  width: 100;
  height: "auto";
  border-radius: 8;
`;
